import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { getListeOf, getCours, getListeOfFacturation } from '../actions';
import { getOfsGroupByClientAndTransport, getOfsToFact } from '../selectors/ofsSelector';
import LivraisonItem from '../components/livraisonItem';
import { facturerExtensia, facturerNormale } from '../actions/facturation';

const Livraison = ({ getListeOf, getCours, ofsToFact, getListeOfFacturation, cours }) => {
    useEffect(() => {
        getListeOf();
        getCours();
        getListeOfFacturation();
    }, [getListeOf, getCours, getListeOfFacturation]);

    const facturerOfs = useCallback(async (ofs, port) => {
        if (window.confirm('Enregistrer les factures ?')) {
            const ofsParEcheance = ofs.reduce((groupedData, of) => {
                if (!groupedData[of.echeance]) {
                    groupedData[of.echeance] = [];
                }
                groupedData[of.echeance].push(of);
                return groupedData;
            }, {});

            for (const echeance in ofsParEcheance) {
                const facture = ofsParEcheance[echeance];
                const prodExtensia = facture[0].nom_ligne === "EXTENSIA";
                let factureIds;
                if (prodExtensia) {
                    factureIds = await facturerExtensia(facture, port, cours);
                } else {
                    factureIds = await facturerNormale(facture, port, cours);
                }
                getListeOf();
                getListeOfFacturation();
                const { factExtensiaId, factureId } = factureIds;

                if (prodExtensia) {
                    window.open(`https://www.extensia-france.com/printers/factExtensiaPrinter.php?listeFact=${factExtensiaId}`, "_blank");
                    window.open(`https://www.extensia-france.com/printers/factPrinter2024.php?listeFact=${factureId}`, "_blank");
                } else {
                    window.open(`https://www.extensia-france.com/printers/factPrinter2024.php?listeFact=${factureId}`, "_blank");
                }

                port = 0;
            }
        }
    }, [cours, getListeOf, getListeOfFacturation]);

    return (
        <div>
            {Object.entries(ofsToFact).map(([idBijouterie, transports]) =>
                Object.entries(transports).flatMap(([transportKey, laboGroup]) =>
                    [0, 1].map(laboValue => {
                        const ofs = laboGroup[laboValue];
                        if (!ofs || ofs.length === 0) return null;

                        const titre = `${transportKey} - ${laboValue === 1 ? 'LABO' : 'STANDARD'}`;
                        //console.log(titre);
                        
                        const uniqueKey = `${idBijouterie}-${transportKey}-${laboValue}`;

                        return (
                            <LivraisonItem
                                key={uniqueKey}
                                ofs={ofs}
                                facturerOfs={facturerOfs}
                                titre={titre}
                            />
                        );
                    })
                )
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    ofsToFact: getOfsGroupByClientAndTransport(state),
    ofs: getOfsToFact(state),
    cours: state.cours.listeCours
});

const mapDispatchToProps = {
    getListeOf,
    getListeOfFacturation,
    getCours
};

export default connect(mapStateToProps, mapDispatchToProps)(Livraison);
